"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GetDefaultElectricityProductInput_1 = tslib_1.__importDefault(require("./GetDefaultElectricityProductInput"));
const GetDefaultGasProductInput_1 = tslib_1.__importDefault(require("./GetDefaultGasProductInput"));
class GetDefaultInputBody extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.Brand)),
    (0, base_models_1.Docs)({
        example: base_models_1.Brand.ENERGIEDIRECT,
        description: `The brand for which you want to retrieve the tariffs.
      The tariffs are specific for each brand.
      We can also only retrieve the grid operator, net area, captar, profile (g1a, e1c, etc.), connect ean, if the giving address is also customer of that brand.
    `,
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultInputBody.prototype, "brand", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, base_models_1.IsAddressKey)(),
    (0, base_models_1.Docs)({
        example: '1234AX_8_B',
        description: 'The address',
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultInputBody.prototype, "addressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.SegmentType)),
    (0, base_models_1.Docs)({
        example: base_models_1.SegmentType.HH,
        description: `Used in the calculation of the tax rates and supply rates.
    If not present it will default to household (HH)`,
    }),
    tslib_1.__metadata("design:type", String)
], GetDefaultInputBody.prototype, "segment", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `Also known as complex bepaling.
      This information is maintained by EDSN.
      For tariffs, if residential is true and complex is false, that address will get belasting voordeel.
      Defaults to false.`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetDefaultInputBody.prototype, "complex", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: false,
        description: `If true it means that is a "regular" home.
    Defaults to true`,
    }),
    tslib_1.__metadata("design:type", Boolean)
], GetDefaultInputBody.prototype, "residential", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetDefaultGasProductInput_1.default),
    tslib_1.__metadata("design:type", GetDefaultGasProductInput_1.default)
], GetDefaultInputBody.prototype, "gasProduct", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GetDefaultElectricityProductInput_1.default),
    tslib_1.__metadata("design:type", GetDefaultElectricityProductInput_1.default)
], GetDefaultInputBody.prototype, "electricityProduct", void 0);
exports.default = GetDefaultInputBody;
